import WOLKEN_LOGO from "../assets/WOLKEN_LOGO.png";

export default function (props) {
  return (
    <div className="custom-spinner">
      <svg
        focusable="false"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 192 192"
      >
        <circle cx="50%" cy="50%" r="95"></circle>
      </svg>
      <img src={WOLKEN_LOGO} alt="" />
    </div>
  );
}
